import { jsxs, jsx } from 'react/jsx-runtime';
import { DialogTitle } from '../../../../node_modules/@radix-ui/react-dialog/dist/index.js';
import classnames from '../../../../node_modules/classnames/index.js';
import modules_773fac34 from './Header.module.scss.js';
import { CustomHeader } from '../CustomHeader/CustomHeader.js';
import { CloseButton } from '../CloseButton/CloseButton.js';
import { Typography } from '../../../Typography/Typography.js';

const Header = ({ children, className }) => {
    return (jsxs(CustomHeader, { className: classnames(modules_773fac34.header, className), children: [jsx(DialogTitle, { "data-header": true, asChild: true, children: jsx(Typography, { variant: "heading-m", children: children }) }), jsx(CloseButton, {})] }));
};

export { Header };
//# sourceMappingURL=Header.js.map
